import { GetTicketsParams } from "@jugl-web/rest-api";
import { TicketInboxFilter } from "@jugl-web/rest-api/tickets/models/common-types/TicketInboxFilter";
import { TicketSortDirection } from "@jugl-web/rest-api/tickets/models/common-types/TicketSortDirection";
import startOfDay from "date-fns/startOfDay";
import endOfDay from "date-fns/endOfDay";

interface BuildGetTicketsQueryParamsOptions {
  filter?: TicketInboxFilter;
  meId?: string;
  contactId?: string;
  searchQuery?: string;
  sort?: TicketSortDirection;
}

/**
 * Translates high-level filter options into raw `GetTicketsParams`.
 */
export const buildGetTicketsQueryParams = ({
  filter,
  meId = "",
  contactId,
  searchQuery,
  sort = "asc",
}: BuildGetTicketsQueryParamsOptions): Omit<GetTicketsParams, "entityId"> => {
  const params: Omit<GetTicketsParams, "entityId"> = {
    searchTerm: searchQuery || undefined,
    sortDir: sort,
    contact: contactId,
  };

  if (!filter) {
    return params;
  }

  switch (filter) {
    case "all":
      params.excludeResolved = true;
      break;
    case "unassigned":
      params.assignee = "unassigned";
      params.excludeResolved = true;
      break;
    case "assigned_to_user":
      params.assignee = meId;
      params.excludeResolved = true;
      break;
    case "todo-today":
      params.dateType = "due_at";
      params.from = startOfDay(new Date()).toISOString();
      params.to = endOfDay(new Date()).toISOString();
      params.assignee = meId;
      params.excludeResolved = true;
      params.sortBy = "due_at";
      break;
    case "recents":
      params.recent = true;
      break;
    default:
      params.status = filter;
      break;
  }

  return params;
};
